(() => {
  function initialize() {
    function formatMoney(cents) {
      if (window.theme?.Currency && window.theme?.settings?.moneyFormat) {
        return window.theme.Currency.formatMoney(cents, window.theme.settings.moneyFormat);
      }
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
    }

    document.querySelectorAll('[data-dolce-shipping-threshold]').forEach((shipping) => {
      const form = shipping.closest('form');
      const products = form?.querySelector('[data-products]');
      if (!products) return;

      const threshold = Number(shipping.dataset.dolceShippingThreshold);
      const message = shipping.querySelector('[data-dolce-shipping-message]');
      const progress = shipping.querySelector('[data-dolce-shipping-progress]');
      const fill = shipping.querySelector('[data-dolce-shipping-fill]');

      function update() {
        const cartItems = products.querySelector('.cart__items');
        const subtotal = Number(cartItems?.dataset.cartSubtotal ?? shipping.dataset.dolceShippingSubtotal);
        if (!Number.isFinite(subtotal) || !Number.isFinite(threshold) || threshold <= 0) return;

        message.textContent = subtotal >= threshold
          ? 'You qualify for free U.S. shipping.'
          : `Add ${formatMoney(threshold - subtotal)} for free U.S. shipping.`;

        const percentage = Math.min(100, Math.max(0, subtotal / threshold * 100));
        fill.style.width = `${percentage}%`;
        progress.setAttribute('aria-valuenow', String(Math.min(threshold / 100, Math.max(0, subtotal / 100))));
      }

      new MutationObserver(update).observe(products, { childList: true });
      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
